import AreaTab from '@/components/permissions/Tabs/AreaTab/AreaTab.vue';

export default {
	name: 'HomePermissionsContent',
	data: () => ({
		name: 'hello',
	}),
	computed: {
		breadcrumbs() {
			return [
				{
					text: 'Inicio',
					link: true,
					exact: true,
					disabled: false,
					to: {
						name: 'Dashboard',
					},
				},
				{
					text: 'Permisos de Aplicación',
					link: true,
					exact: true,
					disabled: false,
					to: {
						name: 'PermissionsHome',
					},
				},
				{
					text: 'Áreas',
					link: true,
					exact: true,
					disabled: true,
					// to: {
					// 	name: 'PermissionHomePage',
					// },
				},
			];
		},
	},
	methods: {},
	components: { AreaTab },
};
